import * as Sentry from '@sentry/react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { convertLocalizationsToMap } from '../helpers/localizations';
import type { ILocalization } from '../interfaces/localizations';

// Custom hook for fetching data
export function useGetLocalizations(url: string | null, names: string[], language: string, defaultValues?: ILocalization[]) {
  const [localizations, setLocalizations] = useState<Map<string, string>>(convertLocalizationsToMap(defaultValues)); // State for data
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling

  useEffect(() => {
    const controller: AbortController = new AbortController();
    const body = {
      query: `query NewQuery($names: [String!]!, $language: LanguageCodeEnum!) {
                translateStrings(names: $names, language: $language) {
                    translations {
                        key
                        value
                    }
                }
            }`,
      variables: {
        names,
        language,
      },
    };
    if (url != null) {
      setLoading(true);
      axios
        .post(url, body, { signal: controller.signal })
        .then((resp) => {
          const serverTranslations = resp.data?.data?.translateStrings?.translations || [];
          setLocalizations(convertLocalizationsToMap(serverTranslations));
        })
        .catch((err) => {
          setLocalizations(convertLocalizationsToMap(defaultValues));
          setError(err);
          Sentry.captureException(err);
        });
      return () => controller.abort();
    }
  }, [url, language, names, defaultValues]); // Dependency array with url

  return { localizations, loading, error };
}
